export default __webpack_public_path__ + "static/media/pexels-dima-valkov-3266703.3740a16c.jpg";